module.exports = __webpack_public_path__ + "static/media/solidarisch.8b2fbfe7.jpg";